import api from 'api/index';
import { format } from 'date-fns';
import { useQuery } from 'react-query';
import { parseError } from 'utils/Api';
import { AppError } from 'utils/AppError';
import {
  PAYROLL_BLOCKED_ERROR,
  PAYROLL_FINALIZED_ERROR,
  PAYROLL_STATUS_CHECK_FAILED_ERROR,
} from '../constants';
import { parsePayrollMonth } from '../utils';

export const usePayrollMonthStatus = (userOrgId: string, payoutMonth: string) => {
  const parsedMonth = parsePayrollMonth(payoutMonth);
  const date = parsedMonth ? format(parsedMonth, 'dd-MM-yyyy') : null;
  const isEnabled = Boolean(userOrgId) && Boolean(date);

  const query = useQuery({
    queryKey: ['bonusPayoutMonthPayrollStatus', userOrgId, date],
    queryFn: () =>
      api.people.getPayrollStatusForGivenDate({
        userOrgId,
        date: date!,
        isDismissalDate: false,
      }),
    enabled: isEnabled,
    retry: false,
  });

  let error: string | null = null;
  if (isEnabled) {
    if (query.isError) {
      error = parseError(query.error as AppError) || PAYROLL_STATUS_CHECK_FAILED_ERROR;
    } else if (query.data?.isFinal) {
      error = PAYROLL_FINALIZED_ERROR;
    } else if (query.data?.isBlocked) {
      error = PAYROLL_BLOCKED_ERROR;
    }
  }

  return {
    error,
    isChecking: isEnabled && query.isLoading,
    isBlocked: Boolean(error) || (isEnabled && query.isLoading),
  };
};
